import { Wrench } from "lucide-react";

const money = (n) => `$${Math.round(Number(n) || 0).toLocaleString()}`;

// What an As-Is unit needs to pass state inspection — the dealer's typed line items and total.
export function EstimateLines({ items = [], total = 0, testId = "estimate-lines" }) {
  if (!items.length) return null;
  return (
    <div data-testid={testId} className="rounded-xl border border-amber-500/40 bg-amber-500/5 overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-2.5 border-b border-amber-500/30 text-amber-300 text-xs font-mono-tech uppercase tracking-widest">
        <Wrench className="h-3.5 w-3.5" /> Needed to pass state inspection
      </div>
      <ul className="divide-y divide-slate-800/80">
        {items.map((it, i) => (
          <li key={i} className="flex items-center justify-between gap-4 px-4 py-2.5 text-sm" data-testid={`estimate-line-${i}`}>
            <span className="text-slate-200">{it.item}</span>
            <span className="font-mono-tech text-slate-300 whitespace-nowrap">{money(it.cost)}</span>
          </li>
        ))}
      </ul>
      <div className="flex items-center justify-between px-4 py-3 bg-slate-950/60 border-t border-amber-500/30">
        <span className="text-sm font-semibold text-slate-200">Estimated total</span>
        <span className="font-heading text-xl font-black text-amber-300" data-testid="estimate-total">{money(total)}</span>
      </div>
    </div>
  );
}
